module.exports = __webpack_public_path__ + "static/img/notext-startripvan.33a30d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-startripvan.png
// module id = P6bq
// module chunks = 1